/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay200,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay401,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay500,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayMutationResponse,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayPathParams,
} from "../../types/pecegePayCreditCardController/PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay.ts";

export const patchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayPathParamsSchema =
  z.object({
    courseFinPersonPaymentId: z.coerce.number().int(),
  }) as unknown as ToZod<PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const patchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay200Schema =
  z.boolean() as unknown as ToZod<PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const patchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay401Schema =
  z.any() as unknown as ToZod<PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const patchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay500Schema =
  z.any() as unknown as ToZod<PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay500>;

export const patchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayMutationResponseSchema =
  z.lazy(
    () => patchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay200Schema,
  ) as unknown as ToZod<PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayMutationResponse>;
